import { SvgIcon, SvgIconProps } from '@mui/material';

const PenIcon = (props: SvgIconProps) => (
  <SvgIcon {...props} sx={{ cursor: 'pointer', ...props.sx }}>
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="pen-icon"
    >
      <path
        d="M12.1594 8.76097L6 14.9203V18L9.07972 18L15.2391 11.8406M12.1594 8.76097L14.3681 6.55234L14.3694 6.55103C14.6734 6.247 14.8257 6.09472 15.0013 6.03768C15.1559 5.98744 15.3225 5.98744 15.4771 6.03768C15.6525 6.09468 15.8047 6.24679 16.1083 6.55039L17.4478 7.88989C17.7527 8.19479 17.9052 8.34731 17.9623 8.5231C18.0126 8.67774 18.0126 8.84431 17.9623 8.99894C17.9052 9.17461 17.7529 9.3269 17.4485 9.63136L17.4478 9.63202L15.2391 11.8406M12.1594 8.76097L15.2391 11.8406"
        stroke="#2E5BE2"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  </SvgIcon>
);

export default PenIcon;
